export function normalizeReviewData(payload) {
  return {
    reviews: Array.isArray(payload?.reviews) ? payload.reviews : [],
    page: Number(payload?.page) || 1,
    pages: Math.max(Number(payload?.pages) || 1, 1),
    total: Number(payload?.total) || 0,
    message: payload?.message || '',
  };
}

export function readMessage(messages, path, fallback = '') {
  const resolved = path
    .split('.')
    .reduce((current, segment) => current?.[segment], messages);

  return typeof resolved === 'string' ? resolved : fallback;
}

export function fillTemplate(template, replacements = {}) {
  return Object.entries(replacements).reduce(
    (value, [key, replacement]) =>
      value.replaceAll(`{{${key}}}`, String(replacement)),
    String(template || ''),
  );
}

export function getReviewCountCopy(messages, count) {
  if (!count) {
    return messages.reviews_zero || 'No reviews yet';
  }

  return count === 1
    ? fillTemplate(messages.reviews_one || '{{count}} review', { count })
    : fillTemplate(messages.reviews_other || '{{count}} reviews', { count });
}

export function getReviewAuthorNumber(review) {
  return review?.userNumber?.userNumber || review?.userNumber || '';
}

export function getReviewInitials(name) {
  const initials = String(name || '')
    .split(' ')
    .map((part) => part.trim()[0])
    .filter(Boolean)
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return initials || '👤';
}

export function getVisiblePages(page, pages) {
  const candidates = new Set([
    1,
    pages,
    page - 2,
    page - 1,
    page,
    page + 1,
    page + 2,
  ]);

  return Array.from(candidates)
    .filter((value) => value >= 1 && value <= pages)
    .sort((left, right) => left - right);
}

export function getMarketplaceDate(date) {
  if (typeof date !== 'string') {
    return '';
  }

  return date.substring(0, 10);
}

export function getReviewTimestamp(review) {
  const value = review?.createdAt || review?.updatedAt;

  if (!value) {
    return 'Date unavailable';
  }

  const parsedDate = new Date(value);

  return Number.isNaN(parsedDate.getTime())
    ? String(value)
    : parsedDate.toLocaleString();
}

export function resolveInitialOwnReviewState({
  currentUser,
  initialOwnReviewState,
  initialReviews,
}) {
  if (!currentUser?.userNumber) {
    return {
      isReviewed: false,
      hasPurchased: false,
      loading: false,
      review: null,
    };
  }

  if (initialOwnReviewState) {
    return {
      isReviewed: Boolean(initialOwnReviewState.isReviewed),
      hasPurchased: Boolean(
        initialOwnReviewState.hasPurchased || initialOwnReviewState.review,
      ),
      loading: false,
      review: initialOwnReviewState.review || null,
    };
  }

  const fallbackReview = normalizeReviewData(initialReviews).reviews.find(
    (review) => getReviewAuthorNumber(review) === currentUser.userNumber,
  );

  return {
    isReviewed: Boolean(fallbackReview),
    hasPurchased: Boolean(fallbackReview),
    loading: false,
    review: fallbackReview || null,
  };
}
